import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "quick-page" }
const _hoisted_2 = { class: "quick-page__header" }
const _hoisted_3 = { class: "quick-page__header-option grow" }
const _hoisted_4 = { class: "quick-page__header-option-label text-gray-400" }
const _hoisted_5 = { class: "quick-page__header-option-control flex items-center" }
const _hoisted_6 = { class: "quick-page__header-option-control-field" }
const _hoisted_7 = { class: "quick-page__header-toggle" }
const _hoisted_8 = { class: "quick-page__header-toggle-label text-gray-400" }
const _hoisted_9 = { class: "quick-page__header-toggle-control flex items-center" }
const _hoisted_10 = { class: "quick-page__header-close" }
const _hoisted_11 = { class: "quick-page__title-input" }
const _hoisted_12 = { class: "quick-page__actions flex justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmojiIcon = _resolveComponent("EmojiIcon")!
  const _component_ListDropdownWrap = _resolveComponent("ListDropdownWrap")!
  const _component_ApplyTemplate = _resolveComponent("ApplyTemplate")!
  const _component_ToggleButton = _resolveComponent("ToggleButton")!
  const _component_EscTooltip = _resolveComponent("EscTooltip")!
  const _component_AutoExpandTextarea = _resolveComponent("AutoExpandTextarea")!
  const _component_Editor = _resolveComponent("Editor")!
  const _component_vue_scroll = _resolveComponent("vue-scroll")!
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_TooltipTemplate = _resolveComponent("TooltipTemplate")!
  const _component_v_popover = _resolveComponent("v-popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "modal quick-page__modal items-start",
      style: _normalizeStyle(_ctx.modalStyle),
      onMousedown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeQuickPage && _ctx.closeQuickPage(...args)))
    }, [
      _createElementVNode("div", {
        class: "quick-page-popup quick-page__popup box-border",
        onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.translate('global.label.createIn')), 1),
            _cache[3] || (_cache[3] = _createTextVNode()),
            _createElementVNode("div", _hoisted_5, [
              (_ctx.icon.type === _ctx.emojiEnum)
                ? (_openBlock(), _createBlock(_component_EmojiIcon, {
                    key: 0,
                    emoji: _ctx.icon.src,
                    classes: 'flex justify-center items-center'
                  }, null, 8, ["emoji"]))
                : (_openBlock(), _createElementBlock("em", {
                    key: 1,
                    class: "quick-page__header-option-control-icon flex items-center",
                    style: _normalizeStyle(_ctx.iconStyle)
                  }, null, 4)),
              _cache[2] || (_cache[2] = _createTextVNode()),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_ListDropdownWrap, {
                  ref: "projectDropdownQP",
                  "dropdown-width": _ctx.dropdownWidth,
                  height: _ctx.dropdownInitialHeight,
                  items: _ctx.dropdownItems,
                  "selected-item": _ctx.selectedProjectIndex,
                  "empty-list-text": _ctx.translate('noBoardsInSpace'),
                  "dropdown-style": {
                    maxHeight: `${_ctx.dropdownHeight}px`,
                  },
                  onItemClick: _ctx.handleAccountClick
                }, null, 8, ["dropdown-width", "height", "items", "selected-item", "empty-list-text", "dropdown-style", "onItemClick"])
              ])
            ]),
            _cache[4] || (_cache[4] = _createTextVNode()),
            _createVNode(_component_ApplyTemplate, {
              class: "quick-page__header-option-control",
              "resource-type": _ctx.resourceType,
              onSelectTemplate: _ctx.handleTemplateSelect
            }, null, 8, ["resource-type", "onSelectTemplate"])
          ]),
          _cache[6] || (_cache[6] = _createTextVNode()),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.translate('quickPage.label.setAsDefaultSpace')), 1),
            _cache[5] || (_cache[5] = _createTextVNode()),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_ToggleButton, {
                "default-value": _ctx.toggleValue,
                onClick: _ctx.toggleDefault
              }, null, 8, ["default-value", "onClick"])
            ])
          ]),
          _cache[7] || (_cache[7] = _createTextVNode()),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_EscTooltip, {
              label: 'global.text.discardDraft',
              "tooltip-meta": {},
              onClosePopup: _ctx.closeQuickPageAndClearTempData
            }, null, 8, ["onClosePopup"])
          ])
        ]),
        _cache[9] || (_cache[9] = _createTextVNode()),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_AutoExpandTextarea, {
            ref: "quickPageTitleInput",
            value: _ctx.tempTitle,
            class: "quick-page__title-input-control text-gray-900",
            "text-value": _ctx.tempTitle,
            "textarea-class": 'quick-page__title-input-control',
            "initial-height": _ctx.titleInputInitialHeight,
            placeholder: _ctx.translate('pageTitle'),
            onInput: _ctx.storeTempValue,
            onEnter: _ctx.focusDescription,
            onEsc: _ctx.closeQuickPage,
            onArrowDownRightEnd: _ctx.focusDescription,
            onTabpress: _ctx.focusDescription
          }, null, 8, ["value", "text-value", "initial-height", "placeholder", "onInput", "onEnter", "onEsc", "onArrowDownRightEnd", "onTabpress"])
        ]),
        _cache[10] || (_cache[10] = _createTextVNode()),
        _createVNode(_component_vue_scroll, {
          ops: {
            scrollPanel: {
              scrollingX: false,
            },
            bar: {
              background: _ctx.spfColor.gray200,
              keepShow: true,
            },
          },
          class: "quick-page__content-input flex overflow-hidden flex-col"
        }, {
          default: _withCtx(() => [
            (_ctx.editorReady)
              ? (_openBlock(), _createBlock(_component_Editor, {
                  key: 0,
                  ref: "quickPageDesc",
                  "resource-type": _ctx.resourceType,
                  "resource-id": 'quick',
                  content: _ctx.pageContent,
                  "watch-content": false,
                  "input-place-holder": _ctx.translate('global.placeholder.pagePlaceholder'),
                  "bottom-gutter": true,
                  draggable: false,
                  "handle-arrow-left": true,
                  onInput: _ctx.textChange,
                  onArrowLeftAtDocStart: _ctx.focusTitle,
                  onEsc: _withModifiers(_ctx.closeQuickPage, ["stop"])
                }, null, 8, ["resource-type", "content", "input-place-holder", "onInput", "onArrowLeftAtDocStart", "onEsc"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["ops"]),
        _cache[11] || (_cache[11] = _createTextVNode()),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_v_popover, null, {
            content: _withCtx(() => [
              _createVNode(_component_TooltipTemplate, {
                "tooltip-text": _ctx.translate('global.text.create'),
                "tooltip-meta": { icon: { ctrl: true, key: 'Enter' } }
              }, null, 8, ["tooltip-text"])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_ButtonCustom, {
                text: _ctx.translate('global.text.create'),
                type: 'important',
                class: "quick-page__actions-item",
                onClick: _ctx.createPage
              }, null, 8, ["text", "onClick"]),
              _cache[8] || (_cache[8] = _createTextVNode())
            ]),
            _: 1
          })
        ])
      ], 32)
    ], 36)
  ]))
}